import { render } from "./font_Awesome.vue?vue&type=template&id=15e16893"
import script from "./font_Awesome.vue?vue&type=script&lang=js"
export * from "./font_Awesome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__